import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { Box, IconButton } from '@mui/material';
import React from 'react';
import { getCardColors } from '../cardColors';
import { CardIconBackground } from './CardIconBackground';
export const CardIconCheckbox = ({ checked, icon, color, onIconClick, iconAriaLabel, iconColor }) => {
    const backgroundColor = getCardColors()[color];
    const sx = { display: 'flex', alignItems: 'center', justifyContent: 'center' };
    const iconBackgroundColor = iconColor ? getCardColors()[iconColor] : undefined;
    return (React.createElement(Box, { sx: Object.assign({ position: 'relative', alignSelf: 'stretch', flexShrink: 0, width: 80, minHeight: 80, backgroundColor: backgroundColor, borderTopLeftRadius: 4, borderBottomLeftRadius: 4 }, sx), "data-test": 'icon' },
        React.createElement(CardIconBackground, null),
        React.createElement(Box, { sx: Object.assign({ position: 'relative', color: backgroundColor }, sx) }, onIconClick ? (React.createElement(IconButton, { onClick: (event) => {
                onIconClick();
                event.stopPropagation();
            }, sx: {
                color: checked ? 'primary.main' : (iconBackgroundColor !== null && iconBackgroundColor !== void 0 ? iconBackgroundColor : backgroundColor),
                '& .card-icon': {
                    display: 'flex',
                },
                '& .card-checkbox': {
                    display: 'none',
                },
                '&:hover': {
                    color: 'primary.main',
                    '& .card-icon': {
                        display: 'none',
                    },
                    '& .card-checkbox': {
                        display: 'flex',
                    },
                },
            }, role: 'checkbox', "aria-label": iconAriaLabel, "aria-checked": checked },
            React.createElement("div", { className: 'card-icon' }, checked ? React.createElement(CheckBoxIcon, null) : icon),
            React.createElement("div", { className: 'card-checkbox' }, checked ? React.createElement(CheckBoxIcon, null) : React.createElement(CheckBoxOutlineBlankIcon, null)))) : (icon))));
};
